/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PendingBackgroundCheckTab_delegate = {
    readonly hasActiveBackgroundCheck: boolean;
    readonly backgroundChecks: ReadonlyArray<{
        readonly uuid: string;
        readonly createdAt: string;
        readonly approvalDate: string | null;
        readonly applicationSentAt: string | null;
        readonly applicationReceivedAt: string | null;
        readonly hasAllResponses: boolean;
        readonly requestedDBS: boolean;
        readonly isRenewal: boolean;
        readonly isVerification: boolean;
        readonly isCAA: boolean;
        readonly onlyDBS: boolean;
        readonly idExpiryDate: string | null;
        readonly dbsExpiryDate: string | null;
        readonly interviewNotes: {
            readonly yourName: string;
        } | null;
        readonly history: ReadonlyArray<{
            readonly uuid: string;
            readonly isArchived: boolean;
            readonly responseSendLogs: ReadonlyArray<{
                readonly emailAddress: string;
                readonly sentAt: string;
            }>;
            readonly employer: {
                readonly uuid: string;
                readonly application: {
                    readonly uuid: string;
                    readonly name: string;
                    readonly contactEmail: string;
                    readonly jobTitle: string;
                    readonly dates: ReadonlyArray<{
                        readonly startDate: string;
                        readonly endDate: string;
                    }>;
                } | null;
                readonly response: {
                    readonly uuid: string;
                    readonly orgName: string;
                    readonly orgContactName: string;
                    readonly datesEmployed: ReadonlyArray<{
                        readonly startDate: string;
                        readonly endDate: string;
                    }>;
                } | null;
            } | null;
            readonly education: {
                readonly uuid: string;
                readonly application: {
                    readonly uuid: string;
                    readonly name: string;
                    readonly contactEmail: string;
                    readonly dates: ReadonlyArray<{
                        readonly startDate: string;
                        readonly endDate: string;
                    }>;
                } | null;
                readonly response: {
                    readonly uuid: string;
                    readonly orgName: string;
                    readonly orgContactName: string;
                    readonly dates: ReadonlyArray<{
                        readonly startDate: string;
                        readonly endDate: string;
                    }>;
                } | null;
            } | null;
            readonly selfEmployed: {
                readonly uuid: string;
                readonly application: {
                    readonly uuid: string;
                    readonly accountantName: string;
                    readonly contactEmail: string;
                    readonly dates: ReadonlyArray<{
                        readonly startDate: string;
                        readonly endDate: string;
                    }>;
                } | null;
                readonly response: {
                    readonly uuid: string;
                    readonly orgName: string;
                    readonly orgContactName: string;
                    readonly dates: ReadonlyArray<{
                        readonly startDate: string;
                        readonly endDate: string;
                    }>;
                } | null;
            } | null;
            readonly unemployed: {
                readonly uuid: string;
                readonly application: {
                    readonly uuid: string;
                    readonly dates: ReadonlyArray<{
                        readonly startDate: string;
                        readonly endDate: string;
                    }>;
                } | null;
                readonly response: {
                    readonly uuid: string;
                    readonly alternateDates: ReadonlyArray<{
                        readonly startDate: string;
                        readonly endDate: string;
                    }>;
                } | null;
            } | null;
            readonly " $fragmentRefs": FragmentRefs<"Timeline_history">;
        }> | null;
    }> | null;
    readonly " $refType": "PendingBackgroundCheckTab_delegate";
};
export type PendingBackgroundCheckTab_delegate$data = PendingBackgroundCheckTab_delegate;
export type PendingBackgroundCheckTab_delegate$key = {
    readonly " $data"?: PendingBackgroundCheckTab_delegate$data;
    readonly " $fragmentRefs": FragmentRefs<"PendingBackgroundCheckTab_delegate">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "uuid",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "contactEmail",
        "args": null,
        "storageKey": null
    } as any), v3 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "startDate",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "endDate",
            "args": null,
            "storageKey": null
        } as any)
    ], v4 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "dates",
        "storageKey": null,
        "args": null,
        "concreteType": "HistoryDates",
        "plural": true,
        "selections": (v3 /*: any*/)
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "orgName",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "orgContactName",
        "args": null,
        "storageKey": null
    } as any), v7 = [
        (v0 /*: any*/),
        (v5 /*: any*/),
        (v6 /*: any*/),
        (v4 /*: any*/)
    ];
    return {
        "kind": "Fragment",
        "name": "PendingBackgroundCheckTab_delegate",
        "type": "Delegate",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasActiveBackgroundCheck",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "backgroundChecks",
                "storageKey": null,
                "args": null,
                "concreteType": "BackgroundCheck",
                "plural": true,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "createdAt",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "approvalDate",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "applicationSentAt",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "applicationReceivedAt",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasAllResponses",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "requestedDBS",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isRenewal",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isVerification",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isCAA",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "onlyDBS",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "idExpiryDate",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "dbsExpiryDate",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "interviewNotes",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "InterviewNotes",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "yourName",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "history",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BackgroundHistory",
                        "plural": true,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isArchived",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "responseSendLogs",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ResponseSendLog",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "emailAddress",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "sentAt",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "employer",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BackgroundHistoryEmployer",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "application",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "BackgroundCheckEmployerApplication",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            (v1 /*: any*/),
                                            (v2 /*: any*/),
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "jobTitle",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            (v4 /*: any*/)
                                        ]
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "response",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "BackgroundCheckEmployerResponse",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            (v5 /*: any*/),
                                            (v6 /*: any*/),
                                            {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "datesEmployed",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "HistoryDates",
                                                "plural": true,
                                                "selections": (v3 /*: any*/)
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "education",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BackgroundHistoryEducation",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "application",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "BackgroundCheckEducationApplication",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            (v1 /*: any*/),
                                            (v2 /*: any*/),
                                            (v4 /*: any*/)
                                        ]
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "response",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "BackgroundCheckEducationResponse",
                                        "plural": false,
                                        "selections": (v7 /*: any*/)
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "selfEmployed",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BackgroundHistorySelfEmployed",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "application",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "BackgroundCheckSelfEmployedApplication",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "accountantName",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            (v2 /*: any*/),
                                            (v4 /*: any*/)
                                        ]
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "response",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "BackgroundCheckSelfEmploymentResponse",
                                        "plural": false,
                                        "selections": (v7 /*: any*/)
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "unemployed",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BackgroundHistoryUnemployed",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "application",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "BackgroundCheckUnemployedApplication",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            (v4 /*: any*/)
                                        ]
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "response",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "BackgroundCheckUnemployedResponse",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "alternateDates",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "HistoryDates",
                                                "plural": true,
                                                "selections": (v3 /*: any*/)
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "Timeline_history",
                                "args": null
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'de2313865f227a5daefd02485d13cc7e';
export default node;
